module.exports = __webpack_public_path__ + "static/img/103043.229f1440.png";